/**
 * Created by dhalman on 9/6/17.
 */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Row, Col, Image, PanelGroup, Panel } from 'react-bootstrap';
import FaqContent from 'src/components/faq-page/faqContent';
import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';

export class FaqPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            url: window.location.href,
            arrows: [true, false],
            activeKey: 1
        };
    }

    componentDidMount() {
        PageTracker.lastPage = Page.FAQ;
    }

    setFooter() {
        const {t} = this.props;
        return (
            <section className="footer generic-page-footer lgray">
                <div className="left">
                    <span>{t('channel.footer.powered')}</span>
                </div>
                <div className="right">
                    <span>
                        <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                           {t('channel.footer.tnc')}
                        </a>
                    </span>
                    <span>
                        <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                           {t('channel.footer.privacy')}
                        </a>
                    </span>
                    <span>{t('channel.footer.copyright')} {t('channel.footer.company')}</span>
                </div>
            </section>);
    }

    getFaqBanner() {
        return (
            <div className="faq__banner">
                <Image src={`${config.assets.url}/images/faq-page/faq-banner.png`} alt="banner-img" responsive />
            </div>);
    }
    getFaqContentText(url) {
        let faqContent = 'organizerTopQuestions';
        if (url.includes('#buildChannel')) {
            faqContent = 'buildChannel';
        } else if (url.includes('#promoteChannel')) {
            faqContent = 'promoteChannel';
        } else if (url.includes('#workWithRecordings')) {
            faqContent = 'workWithRecordings';
        } else if (url.includes('#attendeeTopQuestions')) {
            faqContent = 'attendeeTopQuestions';
        }
        return faqContent;
    }
    getFaqContent() {
        let faqContent = this.getFaqContentText(this.state.url);
        return (
            <div className="faq__content">
                <Row className="clearfix">
                    <Col sm={3} md={3}>
                        {this.getNavItems()}
                    </Col>
                    <Col sm={9} md={9}>
                        <FaqContent faqContent={faqContent} />
                    </Col>
                </Row>
            </div>
        );
    }

    handleClick(data) {
        this.setState({url: data.target.href});
    }
    handleOnNavClick(number) {
        const newArrows = this.state.arrows.map((arrow, index) => {
            if (index === number) {
                return !arrow;
            }
            return false;
        });
        this.setState({arrows: newArrows});
    }
    renderArrowIcon(number, type) {
        const {t} = this.props;
        let arrowClassName = 'fa fa-caret-down faq-caret faq-nav-caret';
        if (this.state.arrows[number]) {
            arrowClassName = 'fa fa-caret-up faq-caret faq-nav-caret';
        }
        return (
            <div>
                <i className={arrowClassName} aria-hidden="true" />{t(`faq.${type}.heading`)}
            </div>
        );
    }
    getNavItems() {
        const {t} = this.props;
        return (
            <div>
                <PanelGroup defaultActiveKey="1" accordion>
                    <Panel header={this.renderArrowIcon(0, 'organizer')} eventKey="1" onSelect={() => { this.handleOnNavClick(0); }}>
                        <div className="faq__nav">
                            <a
                              className={this.state.url.includes('#organizerTopQuestions') || (this.state.url.indexOf('#') === -1) ? 'faq__linkActive' : null}
                              href="#organizerTopQuestions" onClick={this.handleClick.bind(this)}
                            >
                                {t('faq.organizer.topQuestions.heading')}
                            </a>
                            <a className={this.state.url.includes('#buildChannel') ? 'faq__linkActive' : null} href="#buildChannel" onClick={this.handleClick.bind(this)}>
                                {t('faq.organizer.buildChannel.heading')}
                            </a>
                            <a className={this.state.url.includes('#promoteChannel') ? 'faq__linkActive' : null} href="#promoteChannel" onClick={this.handleClick.bind(this)}>
                                {t('faq.organizer.promoteChannel.heading')}
                            </a>
                            <a className={this.state.url.includes('#workWithRecordings') ? 'faq__linkActive' : null} href="#workWithRecordings" onClick={this.handleClick.bind(this)}>
                                {t('faq.organizer.workWithRecordings.heading')}
                            </a>
                        </div>
                    </Panel>
                    <Panel header={this.renderArrowIcon(1, 'attendee')} eventKey="2" onSelect={() => { this.handleOnNavClick(1); }} >
                        <div className="faq__nav">
                            <a className={this.state.url.includes('#attendeeTopQuestions') ? 'faq__linkActive' : null} href="#attendeeTopQuestions" onClick={this.handleClick.bind(this)}>
                                {t('faq.attendee.topQuestions.heading')}
                            </a>
                        </div>
                    </Panel>
                </PanelGroup>
            </div>

        );
    }

    render() {
        return (
            <section className="body">
                <div className="faq__page">
                    {this.getFaqBanner()}
                    {this.getFaqContent()}
                    {this.setFooter()}
                </div>
            </section>
        );
    }
}

FaqPage.propTypes = {
    t: PropTypes.func
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, HeaderActions), dispatch)
)(translate(['translation'])(FaqPage));



// WEBPACK FOOTER //
// ./src/components/faq-page/faqPage.js